// @ts-nocheck
/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';

import Button from './Button';

class BinaryToggle extends React.PureComponent {
  static propTypes = {
    isConfirm: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isConfirm: null,
    testid: 'binary-toggle',
  };

  render() {
    const { isConfirm, onClick, testid } = this.props;

    return (
      <div className="binary-toggle">
        <Button
          onClick={onClick.bind(null, true)}
          type="secondary"
          size="medium"
          selected={isConfirm === true}
          className="h_mstart-5"
          testid={`${testid}-confirm`}
        >
          Yes
        </Button>
        <Button
          onClick={onClick.bind(null, false)}
          type="secondary"
          size="medium"
          selected={isConfirm === false}
          className="h_mstart-5"
          testid={`${testid}-deny`}
        >
          No
        </Button>
      </div>
    );
  }
}

export default BinaryToggle;
